import { Injectable } from "@angular/core";
import { Platform } from "ionic-angular";
import { HttpClient } from "@angular/common/http";
import { Device } from "@ionic-native/device";
import { AppVersion } from "@ionic-native/app-version";
import { Uid } from '@ionic-native/uid';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { AppPreferences, Preference } from "../../shared/local/app-preferences.local";
import { UUID } from "angular2-uuid";

/*
  Generated class for the PlatformServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PlatformServiceProvider {

  /** SCHEMA PLATFORM
    android	on a device running Android.
    cordova	on a device running Cordova.
    core	on a desktop device.
    ios	on a device running iOS.
    ipad	on an iPad device.
    iphone	on an iPhone device.
    mobile	on a mobile device.
    mobileweb	in a browser on a mobile device.
    phablet	on a phablet device.
    tablet	on a tablet device.
    windows	on a device running Windows.
  */

  // Extension Comment Turbo Console Log
  // Ctrl + Alt + L for display comment
  // Shift + Alt + C for show comment - FOR PRODUCTION
  // Shift + Alt + D for delete
  // Shift + Alt + U for uncomment - FOR DEVELOP

  constructor(
    public _platform: Platform,
    private _http: HttpClient,
    private _device: Device,
    private _appVersion: AppVersion,
    private uid: Uid,
    private androidPermissions: AndroidPermissions,
    private appPreferences: AppPreferences
  ) {

  }

  checkPlatform() {
    // console.log("TCL: android", this._platform.is("android"));
    // console.log("TCL: cordova", this._platform.is("cordova"));
    // console.log("TCL: core", this._platform.is("core"));
    // console.log("TCL: ios", this._platform.is("ios"));
    // console.log("TCL: ipad", this._platform.is("ipad"));
    // console.log("TCL: iphone", this._platform.is("iphone"));
    // console.log("TCL: mobile", this._platform.is("mobile"));
    // console.log("TCL: mobileweb", this._platform.is("mobileweb"));
    // console.log("TCL: phablet", this._platform.is("phablet"));
    // console.log("TCL: tablet", this._platform.is("tablet"));
    // console.log("TCL: windows", this._platform.is("windows"));
  }

  // Check platform is TwoPage or One Page
  multiPage(): boolean {
    if (this._platform.is("core") ||
      this._platform.is("ipad") ||
      this._platform.is("tablet") ||
      this._platform.is("phablet") ||
      this._platform.is("windows")) {
      return true;
    }
    return false;
  }

  getPlatform(): Promise<any> {
    return new Promise(async (resolve) => {
      if (this._platform.is("cordova")) {
        resolve(await this.nativePlatform())
      } else {
        resolve(await this.browserPlatform())
      }
    })
  }

  private nativePlatform(): Promise<any> {
    return new Promise(async (resolve) => {
      let number = "";
      let code = "";
      let imei = null;
      try {
        await this._platform.ready();
        number = await this._appVersion.getVersionNumber();
        code = await this._appVersion.getVersionCode();
        if (this._platform.is("android")) {
          imei = await this.getImei();
        }
      } catch (error) { }

      const device = {
        SFGOVersionNumber: number,
        SFGOVersionCode: code,
        Model: this._device.model,
        Platform: this._device.platform,
        Version: this._device.version,
        DeviceID: this._device.uuid,
        IMEI: imei,
        Ready: true
      }

      const deviceInfo = await this.appPreferences.getGreatdayStorage<any>(Preference.GDDeviceInfo);
      if (!deviceInfo) {
        await this.appPreferences.setGreatdayStorage(Preference.GDDeviceInfo, device);
      }

      resolve(device);
    })
  }

  private browserPlatform(): Promise<any> {
    return new Promise(async (resolve) => {
      // var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent;
      var browserName = navigator.appName;
      var fullVersion = '' + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In Chrome, the true version is after "Chrome" 
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version" 
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Firefox, the true version is after "Firefox" 
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent 
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) <
        (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      majorVersion = parseInt('' + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }

      const versionthis = await this.getVersionApps();

      resolve({
        SFGOVersionNumber: versionthis,
        SFGOVersionCode: "",
        Model: browserName,
        Platform: "Web",
        Version: fullVersion,
        DeviceID: `${UUID.UUID()}`,
        IMEI: null,
      })
    })
  }

  private getVersionApps(): Promise<any> {
    return new Promise((resolve) => {
      this._http
        .get('version.json' + "?t=" + new Date().getTime())
        .first()
        .subscribe((response: any) => {
          resolve(response.version);
        }, error => {
          resolve("Development");
        })
    })
  }

  async getImei() {
    try {
      if (this._platform.is("android")) {
        const { hasPermission } = await this.androidPermissions.checkPermission(
          this.androidPermissions.PERMISSION.READ_PHONE_STATE
        );

        if (!hasPermission) {
          const result = await this.androidPermissions.requestPermission(
            this.androidPermissions.PERMISSION.READ_PHONE_STATE
          );

          if (!result.hasPermission) {
            // throw new Error('Permissions required');
          }

          // ok, a user gave us permission, we can get him identifiers after restart app
          return;
        }

        return this.uid.IMEI
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/platform/platform-service.ts